import { WidgetStatePublisher as BasePublisher } from '../../shared/WidgetStatePublisher';
import type { DirectionalDrillingStateParams } from '../types';

export class DirectionalDrillingStatePublisher extends BasePublisher<DirectionalDrillingStateParams> {}
